import { apiClient, setTokens } from './client';
import type {
  TokenObtainRequest,
  TokenPairResponse,
  TokenRefreshRequest,
  TokenAccessResponse,
} from './types';

/**
 * Autentica al usuario y almacena los tokens en localStorage.
 *
 * POST /api/v1/token/
 */
export async function login(
  credentials: TokenObtainRequest,
): Promise<TokenPairResponse> {
  const data = await apiClient.post<TokenPairResponse>(
    '/api/v1/token/',
    credentials,
    undefined,
    true, // skipAuth — endpoint público
  );
  setTokens(data.access, data.refresh);
  return data;
}

/**
 * Obtiene un nuevo access token usando el refresh token.
 *
 * POST /api/v1/token/refresh/
 */
export async function refreshToken(
  body: TokenRefreshRequest,
): Promise<TokenAccessResponse> {
  return apiClient.post<TokenAccessResponse>(
    '/api/v1/token/refresh/',
    body,
    undefined,
    true,
  );
}
